import { Outlet } from 'react-router-dom'

import Tabs from '@/components/Tabs'

const TabItems = [
  { name: 'API 请求日志', to: 'api-timing' },
  { name: '用户管理', to: 'users' },
  { name: 'Bot 管理', to: 'bots' },
  { name: '下级 App 别名', to: 'package-aliases' },
  { name: '产品与国家', to: 'product-tree' },
]

const Index = () => {
  return (
    <main className="flex flex-col">
      <div className="flex gap-4 py-4 sm:gap-2 sm:py-2">
        <h1 className="text-3xl font-semibold">Admin</h1>
      </div>
      <Tabs datas={TabItems} />
      <div className="py-4 sm:py-2">
        <Outlet />
      </div>
    </main>
  )
}

export default Index
